export default __webpack_public_path__ + "static/media/blank_upcoming_examD.56507f75.svg";